.cg{padding:0.5rem;}